'use client';

import { useEffect } from 'react';
import { authRedirectHandled, type RootState } from '@/store';
import { useRouterPush } from '@ianesthesie-kit/core';
import { useAppDispatch, useAppSelector } from '@/hooks';

const selectNeedsLoginRedirect = (state: RootState) =>
  state.misc.needsLoginRedirect;

export function AuthRedirectListener() {
  const push = useRouterPush();
  const dispatch = useAppDispatch();
  const needsRedirect = useAppSelector(selectNeedsLoginRedirect);

  useEffect(() => {
    if (needsRedirect) {
      push('/auth/login');
      dispatch(authRedirectHandled());
    }
  }, [needsRedirect, push, dispatch]);

  return null;
}
